














import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentPriceSubject, ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { LikeSubjectType } from "@scrile/api-provider/dist/api/LikeProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import useOneTimePurchase from "@/hooks/useOneTimePurchase";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { getFullPriceData } from "@/lib/moneyHelpers";
import { PurchaseDetails } from "@/payments/types";
import { BlockingStatus } from "@/types";
import { EVENTS } from "@/const";
import PaymentConfirmation from "@/components/PaymentConfirmation";
import { PaymentConfirmationData } from "@/components/PaymentConfirmation/const";
import { getMessageView } from "./views";

export default defineComponent({
  name: "MessageItem",
  components: { PaymentConfirmation },
  props: {
    message: { type: Object as () => Message, required: true },
    userId: { type: String, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    blockingStatus: { type: Object as () => BlockingStatus, required: true },
    markAsSeen: { type: Boolean, required: true },
  },
  setup(props) {
    const loading = ref(false);
    const paymentSystemId = ref("");

    const viewComponent = computed(() => getMessageView(props.message));
    const data = computed<ContentPriceSubject>(() => ({
      subjectId: props.message.id,
      subjectType: ContentPriceSubjectTypeEnum.MESSAGE_ATTACHMENT,
    }));
    const priceData = computed(() =>
      getFullPriceData(props.paymentPackages.find(i => i.id === props.message.attachmentPricePackageId))
    );

    const purchaseDetails = computed<PurchaseDetails>(() => ({
      pricePackageId: props.message.attachmentPricePackageId ?? "0",
      price: priceData.value.price,
      paymentSystemId: paymentSystemId.value,
      subject: {
        subjectId: props.message.id,
        subjectType: PurchaseSubjectTypeEnum.MESSAGE_ATTACHMENT,
      },
    }));
    const { performOneTimePurchase } = useOneTimePurchase(data, purchaseDetails);

    const purchase = async (data: PaymentConfirmationData) => {
      try {
        if (!props.message.attachmentPricePackageId) {
          return;
        }
        loading.value = true;
        paymentSystemId.value = data.paymentSystemId ?? "";
        const response = await performOneTimePurchase(data.fromBalance);
        if (response.success) {
          emitter.emit(EVENTS.MESSAGES_UPDATE_MESSAGE, props.message.id);
          emitter.emit(EVENTS.NOTIFICATION_SHOW, {
            text: $t("One time buy {0} content for {1}", [
              props.message.senderUser?.screenName,
              data.fromBalance ? priceData.value.creditPrice : priceData.value.price,
            ]),
            image: { user: props.message.senderUser },
            button: { text: $t("Close") },
            position: "top",
          });
        }
      } finally {
        loading.value = false;
      }
    };
    const toggleLike = async () => {
      await providers.LikeProvider.toggle({
        subject: { subjectId: props.message.id, subjectType: LikeSubjectType.MESSAGE },
      });
      emitter.emit(EVENTS.MESSAGES_LIKED_MESSAGE, { messageId: props.message.id });
    };
    return { loading, viewComponent, purchase, toggleLike };
  },
  mounted() {
    this.$emit("rendered", { el: this.$el });
  },
});
